<div class="file-control">
  <ng-container *ngIf="!isButtonElement else buttonElement" [formGroup]="form">
    <label (click)="onClickLabel(input)" (blur)="onTouch($event)">
      <app-svg-icon [icon]="icon"></app-svg-icon>
      <span>{{label}}</span>
    </label>
  </ng-container>
  <ng-template #buttonElement>
    <button class="upload-button" (click)="onClickLabel(input)" (blur)="onTouch($event)">
      <span>{{label}}</span>
      <app-svg-icon [icon]="IconsConstants.UPLOAD_DOCUMENT_ICON"></app-svg-icon>
    </button>
  </ng-template>
  <input #input [multiple]="isMultipleFiles" [accept]="accept" id="browseFile" type="file" (change)="onChangeFiles($event.target, input)" />
  <div class="file-list" *ngIf="files.value?.length > 0">
    <ng-container *ngFor="let file of files.value ; let i = index">
      <div class="file">
        <div class="file-data">
          <app-svg-icon class="file-icon" [icon]="file.name | fileExtensionIcon"></app-svg-icon>
          <span>{{file?.name}}</span>
        </div>
        <div class="file-data">
          <span>{{file?.fileSizeFormat}}</span>
          <button (click)="onDelete(i, input)" class="delete">
            <app-svg-icon [icon]="IconsConstants.CLOSE_ICON_BOLD"></app-svg-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
